const isString = require('lodash/isString');

const list = [
  {
    code: 'en-GB',
    name: 'English (United Kingdom)',
  }, {
    code: 'en-US',
    name: 'English (United States)',
  }, {
    code: 'nl-NL',
    name: 'Dutch (Netherlands)',
  }, {
    code: 'ar-SA',
    name: 'Arabic (Saudi Arabia)',
  }, {
    code: 'bg-BG',
    name: 'Bulgarian',
  }, {
    code: 'ca-ES',
    name: 'Catalan',
  }, {
    code: 'zh-TW',
    name: 'Chinese (Taiwan)',
  }, {
    code: 'cs-CZ',
    name: 'Czech',
  }, {
    code: 'da-DK',
    name: 'Danish',
  }, {
    code: 'de-DE',
    name: 'German (Germany)',
  }, {
    code: 'el-GR',
    name: 'Greek',
  }, {
    code: 'es-ES',
    name: 'Spanish (Spain (Traditional Sort))',
  }, {
    code: 'fi-FI',
    name: 'Finnish',
  }, {
    code: 'fr-FR',
    name: 'French (France)',
  }, {
    code: 'he-IL',
    name: 'Hebrew',
  }, {
    code: 'hu-HU',
    name: 'Hungarian',
  }, {
    code: 'is-IS',
    name: 'Icelandic',
  }, {
    code: 'it-IT',
    name: 'Italian (Italy)',
  }, {
    code: 'ja-JP',
    name: 'Japanese',
  }, {
    code: 'ko-KR',
    name: 'Korean',
  }, {
    code: 'nb-NO',
    name: 'Norwegian (Bokmål)',
  }, {
    code: 'pl-PL',
    name: 'Polish',
  }, {
    code: 'pt-BR',
    name: 'Portuguese (Brazil)',
  }, {
    code: 'rm-CH',
    name: 'Rhaeto (Romanic)',
  }, {
    code: 'ro-RO',
    name: 'Romanian',
  }, {
    code: 'ru-RU',
    name: 'Russian',
  }, {
    code: 'hr-HR',
    name: 'Croatian',
  }, {
    code: 'sk-SK',
    name: 'Slovak',
  }, {
    code: 'sq-AL',
    name: 'Albanian (Albania)',
  }, {
    code: 'sv-SE',
    name: 'Swedish',
  }, {
    code: 'th-TH',
    name: 'Thai',
  }, {
    code: 'tr-TR',
    name: 'Turkish',
  }, {
    code: 'ur-PK',
    name: 'Urdu (Pakistan)',
  }, {
    code: 'id-ID',
    name: 'Indonesian',
  }, {
    code: 'uk-UA',
    name: 'Ukrainian',
  }, {
    code: 'be-BY',
    name: 'Belarusian',
  }, {
    code: 'sl-SI',
    name: 'Slovenian',
  }, {
    code: 'et-EE',
    name: 'Estonian',
  }, {
    code: 'lv-LV',
    name: 'Latvian',
  }, {
    code: 'lt-LT',
    name: 'Lithuanian',
  }, {
    code: 'tg-Cyrl-TJ',
    name: 'Tajik',
  }, {
    code: 'fa-IR',
    name: 'Persian',
  }, {
    code: 'vi-VN',
    name: 'Vietnamese',
  }, {
    code: 'hy-AM',
    name: 'Armenian (Armenia)',
  }, {
    code: 'az-Latn-AZ',
    name: 'Azeri (Latin)',
  }, {
    code: 'eu-ES',
    name: 'Basque',
  }, {
    code: 'wen-DE',
    name: 'Sorbian',
  }, {
    code: 'mk-MK',
    name: 'F.Y.R.O. Macedonian',
  }, {
    code: 'st-ZA',
    name: 'Sutu',
  }, {
    code: 'ts-ZA',
    name: 'Tsonga',
  }, {
    code: 'tn-ZA',
    name: 'Tswana',
  }, {
    code: 'ven-ZA',
    name: 'Venda',
  }, {
    code: 'xh-ZA',
    name: 'Xhosa',
  }, {
    code: 'zu-ZA',
    name: 'Zulu',
  }, {
    code: 'af-ZA',
    name: 'Afrikaans (South Africa)',
  }, {
    code: 'ka-GE',
    name: 'Georgian',
  }, {
    code: 'fo-FO',
    name: 'Faroese',
  }, {
    code: 'hi-IN',
    name: 'Hindi',
  }, {
    code: 'mt-MT',
    name: 'Maltese',
  }, {
    code: 'se-NO',
    name: 'Sami',
  }, {
    code: 'gd-GB',
    name: 'Gaelic (Scotland)',
  }, {
    code: 'yi',
    name: 'Yiddish',
  }, {
    code: 'ms-MY',
    name: 'Malay (Malaysia)',
  }, {
    code: 'kk-KZ',
    name: 'Kazakh',
  }, {
    code: 'ky-KG',
    name: 'Kyrgyz (Cyrillic)',
  }, {
    code: 'sw-KE',
    name: 'Swahili',
  }, {
    code: 'tk-TM',
    name: 'Turkmen',
  }, {
    code: 'uz-Latn-UZ',
    name: 'Uzbek (Latin)',
  }, {
    code: 'tt-RU',
    name: 'Tatar',
  }, {
    code: 'bn-IN',
    name: 'Bengali (India)',
  }, {
    code: 'pa-IN',
    name: 'Punjabi',
  }, {
    code: 'gu-IN',
    name: 'Gujarati',
  }, {
    code: 'or-IN',
    name: 'Oriya',
  }, {
    code: 'ta-IN',
    name: 'Tamil',
  }, {
    code: 'te-IN',
    name: 'Telugu',
  }, {
    code: 'kn-IN',
    name: 'Kannada',
  }, {
    code: 'ml-IN',
    name: 'Malayalam',
  }, {
    code: 'as-IN',
    name: 'Assamese',
  }, {
    code: 'mr-IN',
    name: 'Marathi',
  }, {
    code: 'sa-IN',
    name: 'Sanskrit',
  }, {
    code: 'mn-MN',
    name: 'Mongolian (Cyrillic)',
  }, {
    code: 'bo-CN',
    name: "Tibetan (People's Republic of China)",
  }, {
    code: 'cy-GB',
    name: 'Welsh',
  }, {
    code: 'km-KH',
    name: 'Khmer',
  }, {
    code: 'lo-LA',
    name: 'Lao',
  }, {
    code: 'my-MM',
    name: 'Burmese',
  }, {
    code: 'gl-ES',
    name: 'Galician',
  }, {
    code: 'kok-IN',
    name: 'Konkani',
  }, {
    code: 'mni',
    name: 'Manipuri',
  }, {
    code: 'sd-IN',
    name: 'Sindhi (India)',
  }, {
    code: 'syr-SY',
    name: 'Syriac',
  }, {
    code: 'si-LK',
    name: 'Sinhalese (Sri Lanka)',
  }, {
    code: 'chr-US',
    name: 'Cherokee (United States)',
  }, {
    code: 'iu-Cans-CA',
    name: 'Inuktitut',
  }, {
    code: 'am-ET',
    name: 'Amharic (Ethiopia)',
  }, {
    code: 'tmz',
    name: 'Tamazight (Arabic)',
  }, {
    code: 'ks-Arab-IN',
    name: 'Kashmiri (Arabic)',
  }, {
    code: 'ne-NP',
    name: 'Nepali',
  }, {
    code: 'fy-NL',
    name: 'Frisian (Netherlands)',
  }, {
    code: 'ps-AF',
    name: 'Pashto',
  }, {
    code: 'fil-PH',
    name: 'Filipino',
  }, {
    code: 'dv-MV',
    name: 'Divehi',
  }, {
    code: 'bin-NG',
    name: 'Edo',
  }, {
    code: 'fuv-NG',
    name: 'Fulfulde (Nigeria)',
  }, {
    code: 'ha-Latn-NG',
    name: 'Hausa (Nigeria)',
  }, {
    code: 'ibb-NG',
    name: 'Ibibio (Nigeria)',
  }, {
    code: 'yo-NG',
    name: 'Yoruba',
  }, {
    code: 'quz-BO',
    name: 'Quecha (Bolivia)',
  }, {
    code: 'nso-ZA',
    name: 'Sepedi',
  }, {
    code: 'ig-NG',
    name: 'Igbo (Nigeria)',
  }, {
    code: 'kr-NG',
    name: 'Kanuri (Nigeria)',
  }, {
    code: 'gaz-ET',
    name: 'Oromo',
  }, {
    code: 'ti-ER',
    name: 'Tigrigna (Ethiopia)',
  }, {
    code: 'gn-PY',
    name: 'Guarani (Paraguay)',
  }, {
    code: 'haw-US',
    name: 'Hawaiian (United States)',
  }, {
    code: 'la',
    name: 'Latin',
  }, {
    code: 'so-SO',
    name: 'Somali',
  }, {
    code: 'ii-CN',
    name: 'Yi',
  }, {
    code: 'pap-AN',
    name: 'Papiamentu',
  }, {
    code: 'ug-Arab-CN',
    name: 'Uighur (China)',
  }, {
    code: 'mi-NZ',
    name: 'Maori (New Zealand)',
  }, {
    code: 'ar-IQ',
    name: 'Arabic (Iraq)',
  }, {
    code: 'zh-CN',
    name: "Chinese (People's Republic of China)",
  }, {
    code: 'de-CH',
    name: 'German (Switzerland)',
  }, {
    code: 'es-MX',
    name: 'Spanish (Mexico)',
  }, {
    code: 'fr-BE',
    name: 'French (Belgium)',
  }, {
    code: 'it-CH',
    name: 'Italian (Switzerland)',
  }, {
    code: 'nl-BE',
    name: 'Dutch (Belgium)',
  }, {
    code: 'nn-NO',
    name: 'Norwegian (Nynorsk)',
  }, {
    code: 'pt-PT',
    name: 'Portuguese (Portugal)',
  }, {
    code: 'ro-MD',
    name: 'Romanian (Moldava)',
  }, {
    code: 'ru-MD',
    name: 'Russian (Moldava)',
  }, {
    code: 'sr-Latn-CS',
    name: 'Serbian (Latin)',
  }, {
    code: 'sv-FI',
    name: 'Swedish (Finland)',
  }, {
    code: 'ur-IN',
    name: 'Urdu (India)',
  }, {
    code: 'az-Cyrl-AZ',
    name: 'Azeri (Cyrillic)',
  }, {
    code: 'ga-IE',
    name: 'Gaelic (Ireland)',
  }, {
    code: 'ms-BN',
    name: 'Malay (Brunei Darussalam)',
  }, {
    code: 'uz-Cyrl-UZ',
    name: 'Uzbek (Cyrillic)',
  }, {
    code: 'bn-BD',
    name: 'Bengali (Bangladesh)',
  }, {
    code: 'pa-PK',
    name: 'Punjabi (Pakistan)',
  }, {
    code: 'mn-Mong-CN',
    name: 'Mongolian (Mongolian)',
  }, {
    code: 'bo-BT',
    name: 'Tibetan (Bhutan)',
  }, {
    code: 'sd-PK',
    name: 'Sindhi (Pakistan)',
  }, {
    code: 'tzm-Latn-DZ',
    name: 'Tamazight (Latin)',
  }, {
    code: 'ks-Deva-IN',
    name: 'Kashmiri (Devanagari)',
  }, {
    code: 'ne-IN',
    name: 'Nepali (India)',
  }, {
    code: 'quz-EC',
    name: 'Quecha (Ecuador)',
  }, {
    code: 'ti-ET',
    name: 'Tigrigna (Eritrea)',
  }, {
    code: 'ar-EG',
    name: 'Arabic (Egypt)',
  }, {
    code: 'zh-HK',
    name: 'Chinese (Hong Kong SAR)',
  }, {
    code: 'de-AT',
    name: 'German (Austria)',
  }, {
    code: 'en-AU',
    name: 'English (Australia)',
  }, {
    code: 'es-ES',
    name: 'Spanish (Spain (Modern Sort))',
  }, {
    code: 'fr-CA',
    name: 'French (Canada)',
  }, {
    code: 'sr-Cyrl-CS',
    name: 'Serbian (Cyrillic)',
  }, {
    code: 'quz-PE',
    name: 'Quecha (Peru)',
  }, {
    code: 'ar-LY',
    name: 'Arabic (Libya)',
  }, {
    code: 'zh-SG',
    name: 'Chinese (Singapore)',
  }, {
    code: 'de-LU',
    name: 'German (Luxembourg)',
  }, {
    code: 'en-CA',
    name: 'English (Canada)',
  }, {
    code: 'es-GT',
    name: 'Spanish (Guatemala)',
  }, {
    code: 'fr-CH',
    name: 'French (Switzerland)',
  }, {
    code: 'hr-BA',
    name: 'Croatian (Bosnia/Herzegovina)',
  }, {
    code: 'ar-DZ',
    name: 'Arabic (Algeria)',
  }, {
    code: 'zh-MO',
    name: 'Chinese (Macao SAR)',
  }, {
    code: 'de-LI',
    name: 'German (Liechtenstein)',
  }, {
    code: 'en-NZ',
    name: 'English (New Zealand)',
  }, {
    code: 'es-CR',
    name: 'Spanish (Costa Rica)',
  }, {
    code: 'fr-LU',
    name: 'French (Luxembourg)',
  }, {
    code: 'bs-Latn-BA',
    name: 'Bosnian (Bosnia/Herzegovina)',
  }, {
    code: 'ar-MO',
    name: 'Arabic (Morocco)',
  }, {
    code: 'en-IE',
    name: 'English (Ireland)',
  }, {
    code: 'es-PA',
    name: 'Spanish (Panama)',
  }, {
    code: 'fr-MC',
    name: 'French (Monaco)',
  }, {
    code: 'ar-TN',
    name: 'Arabic (Tunisia)',
  }, {
    code: 'en-ZA',
    name: 'English (South Africa)',
  }, {
    code: 'es-DO',
    name: 'Spanish (Dominican Republic)',
  }, {
    code: 'fr-029',
    name: 'French (West Indies)',
  }, {
    code: 'ar-OM',
    name: 'Arabic (Oman)',
  }, {
    code: 'en-JM',
    name: 'English (Jamaica)',
  }, {
    code: 'es-VE',
    name: 'Spanish (Venezuela)',
  }, {
    code: 'fr-RE',
    name: 'French (Reunion)',
  }, {
    code: 'ar-YE',
    name: 'Arabic (Yemen)',
  }, {
    code: 'en-029',
    name: 'English (Caribbean)',
  }, {
    code: 'es-CO',
    name: 'Spanish (Colombia)',
  }, {
    code: 'fr-CG',
    name: 'French (Democratic Rep. of Congo)',
  }, {
    code: 'ar-SY',
    name: 'Arabic (Syria)',
  }, {
    code: 'en-BZ',
    name: 'English (Belize)',
  }, {
    code: 'es-PE',
    name: 'Spanish (Peru)',
  }, {
    code: 'fr-SN',
    name: 'French (Senegal)',
  }, {
    code: 'ar-JO',
    name: 'Arabic (Jordan)',
  }, {
    code: 'en-TT',
    name: 'English (Trinidad)',
  }, {
    code: 'es-AR',
    name: 'Spanish (Argentina)',
  }, {
    code: 'fr-CM',
    name: 'French (Cameroon)',
  }, {
    code: 'ar-LB',
    name: 'Arabic (Lebanon)',
  }, {
    code: 'en-ZW',
    name: 'English (Zimbabwe)',
  }, {
    code: 'es-EC',
    name: 'Spanish (Ecuador)',
  }, {
    code: 'fr-CI',
    name: "French (Cote d'Ivoire)",
  }, {
    code: 'ar-KW',
    name: 'Arabic (Kuwait)',
  }, {
    code: 'en-PH',
    name: 'English (Philippines)',
  }, {
    code: 'es-CL',
    name: 'Spanish (Chile)',
  }, {
    code: 'fr-ML',
    name: 'French (Mali)',
  }, {
    code: 'ar-AE',
    name: 'Arabic (U.A.E.)',
  }, {
    code: 'en-ID',
    name: 'English (Indonesia)',
  }, {
    code: 'es-UY',
    name: 'Spanish (Uruguay)',
  }, {
    code: 'fr-MA',
    name: 'French (Morocco)',
  }, {
    code: 'ar-BH',
    name: 'Arabic (Bahrain)',
  }, {
    code: 'en-HK',
    name: 'English (Hong Kong SAR)',
  }, {
    code: 'es-PY',
    name: 'Spanish (Paraguay)',
  }, {
    code: 'fr-HT',
    name: 'French (Haiti)',
  }, {
    code: 'ar-QA',
    name: 'Arabic (Qatar)',
  }, {
    code: 'en-IN',
    name: 'English (India)',
  }, {
    code: 'es-BO',
    name: 'Spanish (Bolivia)',
  }, {
    code: 'en-MY',
    name: 'English (Malaysia)',
  }, {
    code: 'es-SV',
    name: 'Spanish (El Salvador)',
  }, {
    code: 'en-SG',
    name: 'English (Singapore)',
  }, {
    code: 'es-HN',
    name: 'Spanish (Honduras)',
  }, {
    code: 'es-NI',
    name: 'Spanish (Nicaragua)',
  }, {
    code: 'es-PR',
    name: 'Spanish (Puerto Rico)',
  }, {
    code: 'es-US',
    name: 'Spanish (United States)',
  }, {
    code: 'es-419',
    name: 'Spanish (Latin America)',
  }, {
    code: 'fr-015',
    name: 'French (North Africa)',
  },
];

class Langs extends Array {
  static CodePrimary = {
    EN_US: 'en-US',
    EN_GB: 'en-GB',
    NL_NL: 'nl-NL',
  };

  static #instance;

  static getInstance() {
    if (!Langs.#instance) {
      Langs.#instance = Object.freeze(new Langs(...list));
    }
    return Langs.#instance;
  }

  constructor(...args) {
    super(...args);
  }

  findOneByCode(code) {
    if (!isString(code)) throw new TypeError('Argument must be a string');
    return this.find(item => item.code === code);
  }

  findOneByName(name) {
    if (!isString(name)) throw new TypeError('Argument must be a string');
    return this.find(item => item.name === name);
  }

  findManyByCodes(codes) {
    if (!Array.isArray(codes)) throw new TypeError('Argument must be an array');
    const result = new Langs();
    codes.forEach((code) => {
      const lang = this.findOneByCode(code);
      if (lang) {
        result.push(lang);
      }
    });

    return result;
  }

  findManyByNames(names) {
    if (!Array.isArray(names)) throw new TypeError('Argument must be an array');
    const result = new Langs();
    names.forEach((name) => {
      const lang = this.findOneByName(name);
      if (lang) {
        result.push(lang);
      }
    });

    return result;
  }

  findNameByCode(code) {
    return (this.findOneByCode(code))?.name;
  }

  findCodeByName(name) {
    return (this.findOneByName(name))?.code;
  }

  getCodes() {
    return this.map(({ code }) => code);
  }

  getNames() {
    return this.map(({ name }) => name);
  }

  findNamesByCodes(codes) {
    return this.findManyByCodes(codes).getNames();
  }

  findCodesByNames(names) {
    return this.findManyByNames(names).getCodes();
  }

  getListPrimary() {
    const codesPrimary = Object.values(Langs.CodePrimary);
    return Langs.#instance.filter(({ code }) => codesPrimary.includes(code));
  }

  getCodesPrimary() {
    return Object.values(Langs.CodePrimary);
  }

  getNamesPrimary() {
    return this.getListPrimary().getNames();
  }

  getLanguageByCurrency(currency) {
    if (currency === 'EUR') return Langs.CodePrimary.NL_NL;
    if (currency === 'GBP') return Langs.CodePrimary.EN_GB;
    if (currency === 'USD') return Langs.CodePrimary.EN_US;
    return Langs.CodePrimary.EN_GB;
  }

  /* TODO: implement:
   * - findPrimaryByCode
   * - findPrimaryByName
   * - improve performance
   * - write unit tests for new logic
   */
}

module.exports = Langs;
